import { useMemo } from "react";
import { arrayComparer, useMessageToState } from "../../../hooks/useMessageToState";

function getPhotoSelection(editor: eXpress.core.IEditor): readonly eXpress.core.Photo[] {
	return editor.definition
		? editor.assets.photoSelection.filter(
				(photo) => photo.isInPhotoSelection && photo.photoSourceType === "photo",
		  )
		: [];
}

/**
 * Hook that returns valid urls to show in the photo selection list.
 * This list must be updated when photos are uploaded/downloaded
 */
export const usePhotoSelection = () => {
	const photos = useMessageToState({
		name: "usePhotoSelection",
		filterMessage: eXpress.core.isPhotoSelectionChanged,
		getState: getPhotoSelection,
		comparer: arrayComparer,
	});

	return useMemo(() => photos.orderBy(eXpress.core.Photo.compareByDateTakenAscending), [photos]);
};
